export default {
    ufRangePickerInput: '/calls/input/rangePicker',
    ufSearchButton: '/calls/button/search',
    ufPhoneIcon: '/calls/table/icon/phone',
};
